const MODULE = "UTILS_";

export const DOWNLOAD_FILE = `${MODULE}download-file`;
export type DOWNLOAD_FILE = typeof DOWNLOAD_FILE;